module.exports = __webpack_public_path__ + "img/right.ac623ce2.png";